const BASE = import.meta.env.VITE_ONBOARDING_API_URL || ''
const TIMEOUT_MS = 30_000

function makeUrl(path, params) {
  let url = `${BASE}${path}`
  if (params && typeof params === 'object') {
    const qs = new URLSearchParams()
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.set(k, String(v))
    })
    const s = qs.toString()
    if (s) url += `?${s}`
  }
  return url
}

async function request(method, path, body, params) {
  const controller = new AbortController()
  const t = setTimeout(() => controller.abort(), TIMEOUT_MS)
  try {
    const res = await fetch(makeUrl(path, params), {
      method,
      credentials: 'omit',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    })
    let data = null
    const ct = res.headers.get('content-type') || ''
    if (ct.includes('application/json')) {
      try {
        data = await res.json()
      } catch {
        data = null
      }
    } else {
      data = await res.text().catch(() => null)
    }
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        data,
        error: (data && data.error) || `HTTP ${res.status}`,
      }
    }
    return { ok: true, status: res.status, data }
  } catch (err) {
    return {
      ok: false,
      status: 0,
      data: null,
      error: err.name === 'AbortError' ? 'timeout' : err.message || 'network-error',
    }
  } finally {
    clearTimeout(t)
  }
}

export function apiPost(path, body) {
  return request('POST', path, body, null)
}

export function apiGet(path, params) {
  return request('GET', path, null, params)
}
